import React, {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FlaskConical, ArrowRight} from 'lucide-react';
import {api} from '../../lib/api';
import './simulation.css';

export const SimulationBanner = () => {
  const location = useLocation();
  const [state, setState] = useState(null);
  const [error, setError] = useState(false);
  const load = () => api.get('/api/simulation/status').then(r => {setState(r.data); setError(false);}).catch(() => setError(true));
  useEffect(() => {load(); const timer = setInterval(load, 30000); return () => clearInterval(timer);}, [location.pathname]);
  if (error) return <div className="sim-banner" role="alert" data-testid="simulation-status-error">Data mode could not be verified.<button onClick={load} className="btn2 sm" data-testid="simulation-status-retry">Retry</button></div>;
  if (!state?.enabled) return null;
  return <aside className="sim-banner" data-testid="simulation-mode-banner">
    <div><strong data-testid="simulation-mode-label"><FlaskConical size={17}/>{state.clean_opening?' CLEAN PREVIEW':' SIMULATION'}</strong><span data-testid="simulation-protection-note">{state.clean_opening?'Opening stock copy · preview actions stay separate from main inventory':'Practice data only · real stock protected · external actions disabled'}</span></div>
    <Link to="/simulation" data-testid="simulation-open-walkthrough">{state.clean_opening?'Workspace status':'Explore scenarios'} <ArrowRight size={16}/></Link>
  </aside>;
};